import { render } from "./main_back_button.vue?vue&type=template&id=aef68ed4&scoped=true"
import script from "./main_back_button.vue?vue&type=script&lang=js"
export * from "./main_back_button.vue?vue&type=script&lang=js"

import "./main_back_button.vue?vue&type=style&index=0&id=aef68ed4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef68ed4"]])

export default __exports__